<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<!--INSERT CUSTOM POPUP FIELDS-->
	<label>Locker Number:</label>
	<input [disabled]="IsLoading() == true" class="form-control" type="text" placeholder="" [(ngModel)]="LockerNum" />

	<label>Currently Assigned to:</label>
	<label class="InfoText">{{ AssignedToDesc }}</label>

	<label>Assigned Date:</label>
	<label>{{ AssignedDTDesc }}</label>

	<label>Assigned Comments:</label>
	<textarea class="form-control" [disabled]="CanEditAssignedComments() == false" [(ngModel)]="AssignedComments"></textarea>

	<label>Assignable:</label>
	<input
		[disabled]="(CanMakeAssignable == false && Assignable == false) || IsLoading() == true"
		class="form-control"
		type="checkbox"
		[(ngModel)]="Assignable"
	/>

	<label>Locker Comments:</label>
	<textarea class="form-control" [disabled]="IsLoading() == true" [(ngModel)]="Comments"></textarea>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onEdit()">Update</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
